// src/data/exercises/L1_05.js

const accountOptions = [
  '売掛金', '貸倒引当金', '貸倒損失', '当座預金', '普通預金'];

export const L1_05 = {
  title: '簿記　3級（第217-5回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {

        parts: [
        { type: 'ruby', text: '岡山', ruby: 'おかやま' },
        { type: 'ruby', text: '株式会社', ruby: 'かぶしきがいしゃ' },
        { type: 'text', value: 'は，' },
        { type: 'ruby', text: '当期', ruby: 'とうき' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '生', ruby: 'しょう' },
        { type: 'text', value: 'じた' },
        { type: 'ruby', text: '広島', ruby: 'ひろしま' },
        { type: 'ruby', text: '株式会社', ruby: 'かぶしきがいしゃ' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '対', ruby: 'たい' },
        { type: 'text', value: 'する' },
        { type: 'ruby', text: '売掛金', ruby: 'うりかけきん' },
        { type: 'text', value: '￥770,000が' },
        { type: 'ruby', text: '回収不能', ruby: 'かいしゅうふのう' },
        { type: 'text', value: 'となり，その' },
        { type: 'ruby', text: '全額', ruby: 'ぜんがく' },
        { type: 'text', value: 'について' },
        { type: 'ruby', text: '貸倒処理', ruby: 'かしだおれしょり' },
        { type: 'text', value: 'を' },
        { type: 'ruby', text: '行', ruby: 'おこな' },
        { type: 'text', value: 'った。' }
    ],

      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '貸倒損失', debitAmount: 770000, creditAccount: '売掛金', creditAmount: 770000 },
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '売掛金￥770,000が回収不能 \n' },
          { type: 'text', value: '①売掛金が回収不能なので、売掛金が減少（マイナス）します。\n' },
          { type: 'styled', value: '売掛金の減少（マイナス）は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '当期に生じた広島株式会社に対する売掛金￥770,000が回収不能・・・貸倒処理を行った。\n' },
          { type: 'text', value: '②当期・回収不能・貸倒処理なので、貸倒損失の発生です。\n' },
          { type: 'styled', value: '貸倒損失の発生は借方（左・Ｄｒ）に記入します。', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`売掛金￥770,000が回収不能
①売掛金が回収不能なので、売掛金が減少（マイナス）します。

当期に生じた広島株式会社に対する売掛金￥770,000が回収不能...貸倒処理を行った。
②当期・回収不能・貸倒処理なので、貸倒損失の発生です。`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
           parts: [
          { type: 'text', value: '売掛金￥770,000が回収不能 \n' },
          { type: 'text', value: '①売掛金が回収不能なので、売掛金が減少（マイナス）します。\n' },
          { type: 'styled', value: '売掛金の減少（マイナス）は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '当期に生じた広島株式会社に対する売掛金￥770,000が回収不能・・・貸倒処理を行った。\n' },
          { type: 'text', value: '②当期・回収不能・貸倒処理なので、貸倒損失の発生です。\n' },
          { type: 'styled', value: '貸倒損失の発生は借方（左・Ｄｒ）に記入します。', color: 'red', bold: true },
        ]
          }
        ],
        
      },
    },
  ],
};